import { EditableComponent } from '@website-builder/model/structure/editable-component.interface';
import { BuilderElementPosition } from '@website-builder/model/structure/builder-element-position';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';
import { BuilderWidgetType } from '@website-builder/model/state/builder-widget.type';
import { GeneralStyle } from '@website-builder/model/style/general-style';

export abstract class BaseWidget<TStyle extends GeneralStyle = GeneralStyle> implements EditableComponent {
  id = makeEntityId(EntityIdPrefix.WIDGET);
  name: string;
  builderElementPosition: BuilderElementPosition;
  abstract type: BuilderWidgetType;
  abstract style: TStyle;
}
